import { combineReducers } from '@reduxjs/toolkit';

import * as usersActions from './users/slice';
import usersSlice from './users/slice';
import * as platformsActions from './platforms/slice';
import platformsSlice from './platforms/slice';
import lanesSlices from './platforms/wimLanes/slice';
import * as lanesActions from './platforms/wimLanes/slice';
import * as groupsActions from './groups/slice';
import groupsSlice from './groups/slice';
import * as wimGroupsActions from './platforms/wimGroups/slice';
import wimGroupsSlice from './platforms/wimGroups/slice';
import * as systemSettingsActions from './settings/slice';
import systemSettingsSlice from './settings/slice';
import * as certificatesActions from './certificates/slice';
import certificatesSlice from './certificates/slice';
import * as notificationsActions from './notifications/slice';
import notificationsSlice from './notifications/slice';
import userGroupSlice from './usergroups/slice';
import * as userGroupsActions from './usergroups/slice';
import dumpSlice from './dump/slice';
import * as dumpActions from './dump/slice';
import * as validationRulesActions from './validation-rules/slice';
import validationRulesSlice from './validation-rules/slice';

export const adminSlices = combineReducers({
  users: usersSlice,
  platforms: platformsSlice,
  lanes: lanesSlices,
  groups: groupsSlice,
  wimGroups: wimGroupsSlice,
  systemSettings: systemSettingsSlice,
  certificates: certificatesSlice,
  notifications: notificationsSlice,
  usergroups: userGroupSlice,
  dumps: dumpSlice,
  validationRules: validationRulesSlice,
});

export const adminActions = {
  users: { ...usersActions },
  platforms: { ...platformsActions },
  lanes: { ...lanesActions },
  groups: { ...groupsActions },
  wimGroups: { ...wimGroupsActions },
  systemSettings: { ...systemSettingsActions },
  certificates: { ...certificatesActions },
  notifications: { ...notificationsActions },
  usergroups: { ...userGroupsActions },
  dumps: { ...dumpActions },
  validationRules: { ...validationRulesActions },
};
